"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const databaseFactory_1 = __importDefault(require("./databaseFactory"));
const Relationizer_1 = __importDefault(require("./Relationizer"));
class Normalizer extends Relationizer_1.default {
    normalize(entity, schema, db) {
        return schema.fold(entity, db, this._run);
    }
    _run(db, objectsToNormalize, schemaId) {
        const schema = this.getSchema(schemaId);
        if (Array.isArray(objectsToNormalize)) {
            return objectsToNormalize.map(object => {
                if (typeof object != 'object' || object == null)
                    return object;
                schema.fold(object, db, this._run);
                return object.id ? object.id : object;
            });
        }
        if (typeof objectsToNormalize != 'object' || objectsToNormalize == null)
            return objectsToNormalize;
        const normalized = schema.fold(objectsToNormalize, db, this._run);
        return objectsToNormalize.id ? objectsToNormalize.id : normalized;
    }
    run(objectsToNormalize, schemaId, options = {}) {
        this.db = (0, databaseFactory_1.default)(options.dbType);
        this._run(this.db, objectsToNormalize, schemaId);
        return this.db.collections;
    }
}
exports.default = Normalizer;
